module.exports = __webpack_public_path__ + "img/icon_map_2_c.910f8b49.png";